import React from "react";
import { CampaignData } from "../../types";
import { EmailContentCreation } from "./email-content-creation";
import { SmsContentCreation } from "./sms/sms-content-creation";
import VoiceBroadcast from "./broadcast";
import { SingleCampaignResponse } from "../../../pages/campaign/types";
import Messaging from "./messaging";

interface CampaignAiProps {
  campaignData: CampaignData;
  singleCampaign: SingleCampaignResponse | null;
  setCampaignData: React.Dispatch<React.SetStateAction<CampaignData>>;
  onSubmit: (data: Partial<CampaignData>) => void;
  onValidation: (isValid: boolean) => void;
  onBack: () => void;
}

export const AIContentCreation: React.FC<CampaignAiProps> = ({
  campaignData,
  singleCampaign,
  setCampaignData,
  onSubmit,
  onValidation,
  onBack,
}) => {
  switch (campaignData.campaign_channel) {
    case "sms":
      return (
        <SmsContentCreation
          campaignData={campaignData}
          singleCampaign={singleCampaign}
          setCampaignData={setCampaignData}
          onSubmit={onSubmit}
          onValidation={onValidation}
          onBack={onBack}
        />
      );

    case "email":
      return (
        <EmailContentCreation
          campaignData={campaignData}
          setCampaignData={setCampaignData}
          onSubmit={onSubmit}
          onValidation={onValidation}
        />
      );

    case "voice":
      return (
        <VoiceBroadcast
          campaignData={campaignData}
          setCampaignData={setCampaignData}
          onSubmit={onSubmit}
          onValidation={onValidation}
        />
      );

    case "whatsapp":
      return (
        <Messaging
          campaignData={campaignData}
          setCampaignData={setCampaignData}
          onSubmit={onSubmit}
          onValidation={onValidation}
                 onBack={onBack}
        />
      );

    default:
      return null;
  }
};
